import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useToast } from '@chakra-ui/react';
import PeriodLockedModal from '../../Components/Common/PeriodLockedModal';

const EVENT_NAME = 'periodLocked:trigger';

const PeriodLockedContext = createContext({
  isOpen: false,
  payload: null,
  open: () => {},
  close: () => {},
});

export const PeriodLockedProvider = ({ children }) => {
  const [payload, setPayload] = useState(null);
  const toast = useToast({ position: 'top-right' });

  const close = useCallback(() => setPayload(null), []);

  const open = useCallback(
    (data) => {
      const detail = data || null;
      setPayload(detail);
      if (detail) {
        toast({
          title: 'Período bloqueado',
          description:
            detail.message || 'No se pudo completar la acción porque el período está bloqueado.',
          status: 'warning',
          duration: 3500,
          isClosable: true,
        });
      }
    },
    [toast]
  );

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const handler = (event) => open(event.detail);
    window.addEventListener(EVENT_NAME, handler);
    return () => window.removeEventListener(EVENT_NAME, handler);
  }, [open]);

  const contextValue = useMemo(
    () => ({
      isOpen: Boolean(payload),
      payload,
      open,
      close,
    }),
    [payload, open, close]
  );

  return (
    <PeriodLockedContext.Provider value={contextValue}>
      {children}
      <PeriodLockedModal isOpen={Boolean(payload)} payload={payload} onClose={close} />
    </PeriodLockedContext.Provider>
  );
};

export const usePeriodLocked = () => useContext(PeriodLockedContext);
